import { clientShopId } from '../config/const';
import { callTpFetch, idTokenHeader, tokenHeader } from './utils';

const EndPoint = {
  GetOrders: (lineId) =>
    `/linewebhook/order/shop/${clientShopId}/${lineId}?where={"is_archive":false}`,
  GetOrder: (lineId, orderId) =>
    `/linewebhook/order/shop/${clientShopId}/${lineId}/${orderId}`,
  SubmitOrder: (lineId) => `/linewebhook/order/shop/${clientShopId}/${lineId}`,
  SubmitRefund: (lineId) =>
    `/linewebhook/refund/shop/${clientShopId}/apply/${lineId}`,
  GetPaymentLink: (lineId, orderId) =>
    `/linewebhook/order/shop/${clientShopId}/${lineId}/${orderId}/payment-link`,
  GetRewardPoint: (lineId, items) =>
    `/linewebhook/order/shop/${clientShopId}/${lineId}/reward-point?items=${items}`,

  GetPurchaseLink: (lineId, items) =>
    `linewebhook/order/shop/${clientShopId}/${lineId}/purchase-now-link?items=${
      items ? `items=${items}` : ''
    }`,
};

// Order

export function getOrders(lineId, idToken) {
  const uri = EndPoint.GetOrders(lineId);
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function submitOrder(lineId, idToken, customerMeta, carts) {
  const uri = EndPoint.SubmitOrder(lineId);
  let settings = {
    method: 'POST',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
    body: JSON.stringify({ items: carts, meta: customerMeta }),
  };

  return callTpFetch(uri, settings);
}

export function getPurchaseLink(lineId, idToken, items) {
  const uri = EndPoint.GetPurchaseLink(lineId, items);
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getPaymentLink(lineId, idToken, orderId) {
  const uri = EndPoint.GetPaymentLink(lineId, orderId);
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getRewardPoint(lineId, idToken) {
  const uri = EndPoint.GetRewardPoint(lineId);
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function getOrder(lineId, orderId, idToken) {
  const uri = EndPoint.GetOrder(lineId, orderId);
  let settings = {
    method: 'GET',
    headers: { ...idTokenHeader(idToken), ...tokenHeader },
  };

  return callTpFetch(uri, settings);
}

export function submitRefund(lineId, orderId, idToken, data) {
  const uri = EndPoint.SubmitRefund(lineId, orderId);
  let formData = new FormData();
  data.files.forEach((file) => {
    formData.append('files', file, file.name);
  });
  formData.append('order_id', orderId);
  formData.append('reason', data.reason);

  let headers = new Headers();
  headers.append('tappie-id-token', idToken.token);

  let settings = {
    method: 'POST',
    headers: headers,
    body: formData,
  };

  return callTpFetch(uri, settings);
}
